export default __webpack_public_path__ + "media/changemakers-for-old-collections.27a01f958a410db27c922a0e93bf508a.svg";